import React from 'react';
import ProjectsPageLayout from '../components/ProjectsPage/ProjectsPageLayout';

const Projects: React.FC = () => <ProjectsPageLayout />;

export default Projects;
